module.exports = __webpack_public_path__ + "static/img/album_1.833a3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album_1.png
// module id = MeAU
// module chunks = 1